import axiosV1 from "@/plugins/axios/configV1";

export default {
    getTrainings(params = {}) {
        const endpoint = params.tab === "trashed" ? "trainings/trashed" : "trainings";
        return axiosV1.get(endpoint, { params });
    },
    getTraining(id = null) {
        return axiosV1.get(`trainings/view/${id}`);
    },
    viewTraining(id = null) {
        return axiosV1.get(`trainings/view/${id}`);
    },
    addTraining(payload = {}) {
        let formData = new FormData();
        for (const key in payload) {
            if (key === "visibility") {
                formData.append(
                    key,
                    !!payload[key].length ? JSON.stringify(payload[key]) : null
                );
            } else if (key === "images") {
                (payload[key] || []).forEach((image) => formData.append("images[]", image));
            } else if (key === "customer_type_ids") {
                (payload[key] || []).forEach((id) => formData.append("customer_type_ids[]", id));
            } else {
                formData.append(key, payload[key] ? payload[key] : "");
            }
        }
        return axiosV1.post("trainings/add", formData);
    },
    updateTraining(id = null, payload = {}) {
        let formData = new FormData();
        for (const key in payload) {
            if (key === "visibility") {
                formData.append(
                    key,
                    !!payload[key].length ? JSON.stringify(payload[key]) : null
                );
            } else if (key === "images") {
                (payload[key] || []).forEach((image) => formData.append("images[]", image));
            } else if (key === "customer_type_ids") {
                (payload[key] || []).forEach((id) => formData.append("customer_type_ids[]", id));
            } else {
                formData.append(key, payload[key] ? payload[key] : "");
            }
        }
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";

        return axiosV1.post(`trainings/update/${id}`, formData);
    },

    exportExcel(params) {
        return axiosV1.get(`trainings/export`, { params });
    },
    deleteTraining(id = null) {
        return axiosV1.post(`trainings/${id}`);
    },
    deleteTrainingAll(ids = {}) {
        return axiosV1.post(`trainings/bulk/delete`, ids);
    },
    recoverTraining(id = null) {
        return axiosV1.post(`trainings/restore/${id}`);
    },
    recoverTrainingAll(ids = {}) {
        return axiosV1.post(`trainings/bulk/recover`, ids);
    },
    destroyTraining(id = null) {
        return axiosV1.post(`trainings/${id}/force-delete`);
    },
    destroyTrainingAll(ids = {}) {
        return axiosV1.post(`trainings/bulk/delete/force`, ids);
    },

    getActivityLogs(id = null) {
        return axiosV1.get(`trainings/audit-log/${id}`);
    },

    // Categories
    getTrainingCategories(params = {}) {
        return axiosV1.get(`training-categories/list`, { params });
    },
    addTrainingCategory(payload = {}) {
        return axiosV1.post(`training-categories`, payload);
    },
    deleteTrainingCategory(id = null) {
        return axiosV1.post(`training-categories/${id}`);
    },
    deleteTrainingCategoryAffected(id = null) {
        return axiosV1.get(`training-categories/delete-affected/${id}`);
    },

    // Customer Types
    getCustomerTypes(params = {}) {
        return axiosV1.get(`customer-types/list`, { params });
    },
};
